(function () {
  'use strict';

  var popover = null;
  var current = null;
  var hideTimer = null;

  function ensurePopover() {
    if (popover) return popover;
    popover = document.createElement('div');
    popover.className = 'hol-switchboard-icon-tip';
    popover.setAttribute('role', 'status');
    popover.setAttribute('aria-live', 'polite');
    document.body.appendChild(popover);
    return popover;
  }

  function hide() {
    window.clearTimeout(hideTimer);
    if (popover) popover.classList.remove('is-visible');
    if (current) current.setAttribute('aria-expanded', 'false');
    current = null;
  }

  function show(trigger, text) {
    var tip = ensurePopover();
    window.clearTimeout(hideTimer);
    tip.textContent = text;
    tip.classList.add('is-visible');
    var triggerRect = trigger.getBoundingClientRect();
    var tipRect = tip.getBoundingClientRect();
    var left = triggerRect.left + triggerRect.width / 2 - tipRect.width / 2;
    left = Math.max(8, Math.min(left, window.innerWidth - tipRect.width - 8));
    var top = triggerRect.top - tipRect.height - 10;
    if (top < 8) top = triggerRect.bottom + 10;
    tip.style.left = Math.round(left) + 'px';
    tip.style.top = Math.round(top) + 'px';
    current = trigger;
    trigger.setAttribute('aria-expanded', 'true');
    hideTimer = window.setTimeout(hide, 4500);
  }

  function bindIcon(icon) {
    var item = icon.closest('.hol-switchboard-feature') || icon;
    var text = icon.getAttribute('data-hol-icon-tip');
    if (!text || item.dataset.holTooltipBound) return;
    item.dataset.holTooltipBound = 'true';
    item.classList.add('has-icon-tip');

    var trigger = document.createElement('span');
    trigger.className = 'hol-switchboard-feature-trigger';
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('tabindex', '0');
    trigger.setAttribute('aria-expanded', 'false');
    var label = item.querySelector('.hol-switchboard-feature-label');
    trigger.setAttribute('aria-label', (label ? label.textContent.trim() : 'Feature') + ', show details');

    while (item.firstChild) trigger.appendChild(item.firstChild);
    item.appendChild(trigger);

    function activate(event) {
      event.preventDefault();
      event.stopPropagation();
      if (current === trigger) {
        hide();
        return;
      }
      show(trigger, text);
    }

    trigger.addEventListener('click', activate);
    trigger.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') activate(event);
    });
  }

  function init(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    container.querySelectorAll('.hol-switchboard-feature-icon[data-hol-icon-tip]').forEach(bindIcon);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('click', function () { if (current) hide(); });
  document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && current) hide(); });
  window.addEventListener('scroll', function () { if (current) hide(); }, { passive: true });
  window.addEventListener('resize', function () { if (current) hide(); });
})();
